import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Remove the anti-collision segment the backend injects into ComfyUI output
 * filenames so the user sees the name they intended.
 *
 * The backend builds output prefixes as `<base>_<00042>-<YYYYMMDD>_<HHMMSS>`
 * and ComfyUI then appends its own `_<counter>` before the extension, e.g.
 * `my-workflow_00042-20260710_143022_00001_.png`. This strips the injected
 * `_<5-digits>-<8-digits>_<6-digits>` segment and the trailing counter,
 * keeping only the base prefix + extension -> `my-workflow.png`.
 *
 * The underlying stored filename/URL is unaffected; this is display-only.
 */
export function displayFileName(filename: string): string {
  const match = filename.match(/^(.*)_\d{5}-\d{8}_\d{6}.*?(\.[^.]+)?$/);
  if (!match) return filename;
  const base = match[1];
  const ext = match[2] || '';
  return `${base}${ext}`;
}
